class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');

    overlay.addEventListener('click', (evt) => {
      if (evt.target === overlay) {
        this.close();
      }
    });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );


    /* lock scroll position */
    this._scrollY = window.scrollY;
    // document.body.style.position = 'fixed';
    /* compensate for missing scrollbar so content doesn't shift */
    const scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarGap > 0) document.body.style.paddingRight = `${scrollBarGap}px`;
    document.body.style.top = `-${this._scrollY}px`;

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    /* unlock scroll and restore previous position */
    const savedY = this._scrollY || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.paddingRight = '';

    /* wait one frame so the browser applies new layout, then scroll back */
    requestAnimationFrame(() => window.scrollTo(0, savedY));
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    updateCartDrawerFromSectionHTML(parsedState.sections['cart-drawer']);

    const iconBubble = document.getElementById('cart-icon-bubble');
    if (iconBubble && parsedState.sections['cart-icon-bubble']) {
      iconBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble'], '.shopify-section');
    }

    setTimeout(() => {
      this.open();
      // Ensure loyalty banner and other listeners refresh after drawer re-render
      try {
        if (typeof updateDrawerPointsFromServer === 'function') {
          updateDrawerPointsFromServer();
        } else {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then((r) => r.json())
            .then((cart) => {
              if (typeof refreshAllLoyaltyBanners === 'function') {
                refreshAllLoyaltyBanners(cart);
              }
              if (typeof fireCartUpdated === 'function') {
                fireCartUpdated(cart);
              } else {
                document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
              }
            })
            .catch(() => {});
        }
      } catch (e) {}
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

